export const ResponsiveMixins = {
    methods: {
        responsiveScreen(xs, sm, md, lg) {
            console.log(window.screen.width)
            if (window.screen.width < 768) {
                return xs
            } else if (window.screen.width < 992) {
                return sm
            } else if (window.screen.width < 1200) {
                return md
            } else {
                return lg
            }
        },
        isMobile() {
            return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        }
    },


}
